import { render, staticRenderFns } from "./GOAuthCallback.vue?vue&type=template&id=d1a76e62&"
import script from "./GOAuthCallback.vue?vue&type=script&lang=ts&"
export * from "./GOAuthCallback.vue?vue&type=script&lang=ts&"
import style0 from "./GOAuthCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports